import $ from 'jquery';

export default class UiService {
  select2_options(width) {
    return {
      containerCssClass: 'multiselect2',
      dropdownCssClass: 'multiselect2',
      width: width + 'px'
    };
  }

  date_options() {
    return {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy',
    };
  }

  open_fancybox_dialog(element) {
    $.fancybox($(element), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: 700,
      closeSpeed: 300,
      topRatio: 0.15,
      scrolling: 'auto'
    });
  }

  close_fancybox_dialog() {
    $.fancybox.close();
  }

  get_counter_css_class(percentage) {
    if (percentage < 50)
      return 'red';
    else if (percentage >= 50 && percentage < 80)
      return 'black';
    else
      return 'green';
  }

  get_icon_css_class(value) {
    return value ? 'success' : 'error';
  }

  get_count_css_class(count) {
    return count > 0 ? 'black' : 'red';
  }

  tinymceOptions() {
    return {
      entity_encoding: 'raw',
      body_class: 'epaper_tinymce',
      content_css : '/stylesheets/tinymce.css',
      height: 200,
      menubar: false,
      statusbar: false,
      plugins: ['link', 'preview', 'code', 'textcolor'],
      toolbar: 'undo redo | bold italic underline | forecolor backcolor | alignleft aligncenter alignright | bullist numlist | link unlink | preview | code'
    };
  }
}



// WEBPACK FOOTER //
// ./front/js/admin/services/ui.service.js